import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './payments.action';
import { Payments } from './payments.model';

export interface PaymentsRecordsState {
    listData: Payments[];
    singleData: Payments;
    loading: boolean;
    error: any;
    total: number;
    paymentsData: {countryList: any[], clubs: any[]}
}

export const initialState: PaymentsRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0,
    paymentsData: {countryList:[], clubs:[]}
};


export const PaymentsRecordReducer = createReducer(

    initialState,
    
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    on(resetState, () => initialState)  // Reset action handler
    
);